export default [
    {
        path: '/billings',
        name: 'Company / Billings',
        component: () => import('@/views/pages/billings'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: ':code',
                name: 'Company / View Billing',
                component: () => import('@/views/pages/billings'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];